// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

export const migrations = {
  2: (state) => ({
    ...state,
    app: {
      ...state.app,
      videoCall: {
        ...state.app.videoCall,
        isDoctorAttended: false,
        screen: {
          isFullScreen: false,
          isDraggable: false,
          isCentred: false,
        },
      },
    },
  }),
};
